module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentDevice) ? _c('div', {
    staticClass: "alert alert-info row",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-8 alert-text--wrap"
  }, [_c('strong', [_vm._v("目前位置")]), _vm._v(" "), _c('p', [_vm._v("\n      第 " + _vm._s(_vm.currentDevice.net.open_times) + " 藥櫃, 第 " + _vm._s(_vm.currentDevice.net.row_id) + " 層\n      "), (_vm.currentDevice.pos_row !== 0) ? _c('span', [_vm._v("\n        , 第 " + _vm._s(_vm.currentDevice.pos_row) + " 列, 第 " + _vm._s(_vm.currentDevice.relative_col) + " 行\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-net col-4"
  }, [_vm._l((_vm.numRow), function(n) {
    return _c('div', {
      staticClass: "small-row",
      style: ({
        order: n,
        height: ((100/_vm.numRow) + "%")
      })
    }, _vm._l((_vm.currentNet.device_set), function(box) {
      return (box.pos_row === n) ? _c('div', {
        class: {
          'small-box': true,
          'current-box': box.pos_row === _vm.currentDevice.pos_row &&
            box.relative_col === _vm.currentDevice.relative_col
        }
      }) : _vm._e()
    }), 0)
  }), _vm._v(" "), (_vm.currentDevice.pos_row === 0) ? _c('div', {
    staticClass: "small-row",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "small-box current-box"
  }, [_vm._v("\n        " + _vm._s(_vm.currentDevice.net.row_id) + "\n      ")])]) : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-577f250c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/CurrentLocationPanel.vue
// module id = 1480
// module chunks = 1